import * as React from 'react';

import { getRTL } from '@fluentui/react/lib/Utilities';

import { MeasuredContext } from '@1js/acui-resize-group';

import { setComponentToMeasure } from '../../utilities';

export interface RibbonEnlightenedComponentProps {
  id?: string;
  offset?: number;
}

/**
 * The RibbonEnlightenedComponent is used to wrap any ribbon content that should respect the gap.
 * This content could be individual controls, entire control groups, etc. It works by adding a div wrapper,
 * registering this wrapper with the RibbonSpanningUtil, and taking in an offset which is applied as margin.
 * This offset shifts the content within the wrapper so that is does not render over the gap. This component
 * should only be used if the ribbon is currently spanning multiple window rects.
 */
export class RibbonEnlightenedComponent extends React.PureComponent<RibbonEnlightenedComponentProps, {}> {
  private wrapper: React.RefObject<HTMLDivElement> = React.createRef();
  public render() {
    return (
      <MeasuredContext.Consumer>
        {({ isMeasured }) => (
          <div
            ref={isMeasured ? this.wrapper : undefined}
            style={getRTL() ? { marginRight: this.props.offset || 0 } : { marginLeft: this.props.offset || 0 }}
          >
            {this.props.children}
          </div>
        )}
      </MeasuredContext.Consumer>
    );
  }

  public componentDidMount() {
    this.setRefComponent();
  }

  public componentDidUpdate() {
    this.setRefComponent();
  }

  private setRefComponent() {
    if (this.wrapper.current && this.props.id) {
      setComponentToMeasure(this.props.id, this.wrapper.current);
    }
  }
}
